__turbopack_context__.v({
  "SoMeIcon": "fSXwqa_SoMeIcon",
  "SoMeLink": "fSXwqa_SoMeLink",
  "SoMeLinkContainer": "fSXwqa_SoMeLinkContainer",
});
